"use client";

import { c as _c } from "react/compiler-runtime";
import { usePersona } from "@opensea/navigation";
import { ATTRIBUTES_VIEW_COOKIE_NAME, getDefaultAttributesView } from "@opensea/navigation/attributes-view";
import { useCookie, useOnChange } from "@opensea/ui-kit/hooks";
import { createContext, useContext } from "react";
import { LONG_LASTING_COOKIE_EXPIRATION } from "@/lib/cookie";
const AttributeViewContext = createContext({
  attributeView: "grid",
  setAttributeView: () => undefined
});
const getDefaultAttributeView = persona => {
  return persona === "collector" ? "grid" : "table";
};
export function ItemAttributesViewProvider(t0) {
  const $ = _c(15);
  const {
    children,
    attributesView: initialAttributesView
  } = t0;
  const {
    persona
  } = usePersona();
  const [attributeView, setAttributeViewCookie] = useCookie(ATTRIBUTES_VIEW_COOKIE_NAME);
  let t1;
  if ($[0] !== attributeView || $[1] !== initialAttributesView || $[2] !== persona) {
    t1 = attributeView ?? initialAttributesView ?? getDefaultAttributesView(persona);
    $[0] = attributeView;
    $[1] = initialAttributesView;
    $[2] = persona;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const resolvedAttributeView = t1;
  let t2;
  if ($[4] !== setAttributeViewCookie) {
    t2 = function setAttributeView(next) {
      setAttributeViewCookie(next, {
        expires: LONG_LASTING_COOKIE_EXPIRATION
      });
    };
    $[4] = setAttributeViewCookie;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const setAttributeView = t2;
  let t3;
  if ($[6] !== persona || $[7] !== setAttributeView) {
    t3 = () => {
      setAttributeView(getDefaultAttributeView(persona));
    };
    $[6] = persona;
    $[7] = setAttributeView;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useOnChange(persona, t3);
  let t4;
  if ($[9] !== resolvedAttributeView || $[10] !== setAttributeView) {
    t4 = {
      attributeView: resolvedAttributeView,
      setAttributeView
    };
    $[9] = resolvedAttributeView;
    $[10] = setAttributeView;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const value = t4;
  let t5;
  if ($[12] !== children || $[13] !== value) {
    t5 = <AttributeViewContext.Provider value={value}>{children}</AttributeViewContext.Provider>;
    $[12] = children;
    $[13] = value;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
export const useAttributeView = () => {
  return useContext(AttributeViewContext);
};